<template>
	<div class="content background1">
		<div class="tableBox9">
			<div class="tableMes">
				<div class="table">
					<el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
						<el-tab-pane label="设备类型" name="first">
							<tree :dataTree="treeData" @getDeviceMes="getDeviceMes"></tree>
						</el-tab-pane>
						<el-tab-pane label="所属区域" name="second">
							<tree :dataTree="treeData2" @getDeviceMes="getDeviceMes"></tree>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
		<div class="tableBox10">
			<div class="tableMes">
				<div class="table" style="padding: 0">
					<div class="treeMes" v-if="getTreeMes=='1'">
						<p class="title"><span class="spot">{{deviceDetailMes.name}}</span>维修审批</p>
						<div class="chooseBox6" style="width: 100%;">
							<div class="selectBox">
								<div>
									<div class="selectChoose">
										<div class="selectText">
											<p>报修时间</p>
										</div>
										<div class="select" style="width:350px">
											<el-date-picker v-model="Readytime" type="daterange" format="yyyy-MM-dd" value-format='yyyy-MM-dd'
											 :range-separator="$t('label_264')" :start-placeholder="$t('label_329')" :end-placeholder="$t('label_388')">
											</el-date-picker>
										</div>
									</div>
								</div>
								<div style="margin-left: 20px;">
									<div class="selectChoose">
										<div class="selectText">
											<p>故障等级</p>
										</div>
										<div class="select" style="width:350px">
											<el-select v-model="faultLevel" placeholder="请选择故障等级">
												<el-option v-for="item in faultLevel2" :key="item.value" :label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</div>
									</div>
								</div>
								<div style="margin-left: 20px;">
									<div class="selectChoose">
										<div class="selectText">
											<p>审批状态</p>
										</div>
										<div class="select" style="width:350px">
											<el-select v-model="changeStatus" placeholder="请选择故障等级">
												<el-option key="全部" label="全部" value=""></el-option>
												<el-option v-for="item in statusList" :key="item.nodeId" :label="item.nodeName" :value="`${item.nodeId}&@${item.nodeName}`">
												</el-option>
												<el-option key="0" label="已结束" value="0&@已结束"></el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
							<div class="buttonBox" style="margin-left: 20px;">
								<div>
									<div class="chooseButton sendButton" @click="search({pageNum: 1,pageSize:pageSize,})"><i class="el-icon-search"></i>查询</div>
								</div>
							</div>
							<div class="selectBox">
								<div>
									<div class="selectChoose">
										<div class="selectText">
											<p>工单编号</p>
										</div>
										<div class="select" style="width:350px">
											<el-input v-model="orderNo" clearable></el-input>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="spotMes2Box">
							<div class="buttonBox" style="margin-left: 20px;">
								<div style="margin-left: 5px;">
									<div class="chooseButton searchButton " @click="approveDetailsShow" v-if="MenuRoleList.indexOf('215')>=0">查看</div>
								</div>
							</div>
							<div class="tableMin" style="height: 100%;">
								<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row border style="width: 100%;margin: 10px 0"
								 :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}" height="100%" @row-click="handleCurrentChangeTreeTime">
									<el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex" width="50">
									</el-table-column>
									<el-table-column prop="orderNo" label="工单编号/状态" align="center" width="200">
										<template slot-scope="scope">
											{{spotStatusNumList[scope.row.status].text}}<br>
											{{scope.row.orderNo}}
										</template>
									</el-table-column>
									<el-table-column prop="superior" label="设备名称" align="left" width="300px">
										<template slot-scope="scope">
											{{scope.row.superior}}<br>
											{{scope.row.tname}} {{scope.row.ename}}<br>
											{{scope.row.code}}
										</template>
									</el-table-column>
									<el-table-column prop="faultPhenomenon" label="故障现象" align="left">
										<template slot-scope="scope">
											{{scope.row.faultPhenomenon}}<br>
											{{scope.row.faultExplain}}
										</template>
									</el-table-column>

									<el-table-column prop="reportPerson" label="报修人员" align="center" width="100px">
										<template slot-scope="scope">
											<p>{{scope.row.reportPerson}}</p>
											<p>{{scope.row.reportTime}}</p>
										</template>
									</el-table-column>
									<el-table-column prop="repairman" label="维修人员" align="center" width="100px">
										<template slot-scope="scope">
											<p>{{scope.row.repairman}}</p>
											<p>{{scope.row.repairBeginTime}}</p>
										</template>
									</el-table-column>
									<el-table-column prop="userName1" label="申请者" align="center" width="100px">
										<template slot-scope="scope">
											<p>{{scope.row.userName1}}</p>
											<p>{{scope.row.createTime1}}</p>
										</template>
									</el-table-column>
									<el-table-column prop="userName2" label="上级审批者" align="center" width="100px">
										<template slot-scope="scope">
											<p>{{scope.row.userName2}}</p>
											<p>{{scope.row.createTime2}}</p>
										</template>
									</el-table-column>
									<el-table-column prop="nodeName" label="审批状态" align="center">
									</el-table-column>
								</el-table>
								<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
								 @parentMethod="search"></Page>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="工单审批" :visible.sync="dialogShow" append-to-body :close-on-click-modal='false' width="1600px"
		 v-dialogDrag top="1%" :before-close="handleClose" custom-class="dialogBox" class="MAdialog">
			<div class="MAdialogBody">
				<iframe v-if="info.taskFileId!=null" frameborder="0" :src="$store.getters.getPostUrl+'mes/sysFile/pdf/'+info.taskFileId"
				 width='100%' height="600px">
				</iframe>
			</div>
			<div class="buttonBox MAbtn">
				<div class="cenDiv" style=" margin-bottom: 15px;">
					<el-switch v-if="swshow" v-model="info.valid" active-color="#13ce66" inactive-color="#ff4949" active-value="0"
					 inactive-value="1" active-text="需要部长审批" inactive-text="不需要部长审批">
					</el-switch>
				</div>
			</div>
			<div class="buttonBox MAbtn">
				<div class="cenDiv">
					<div class="chooseButton searchButton" v-if="info.back!=1" @click="Dshow(2)">{{swshow2==true?'提交':'通过'}}</div>
					<div class="chooseButton searchButton " v-if="!swshow2&&info.back!=1" style="background-color: #e60000;" @click="Dshow(1)">驳回</div>
					<div class="chooseButton searchButton " v-if="swshow2&&info.back!=1" style="background-color: #e60000;" @click="back(1)">驳回到验收环节</div>
					<div class="chooseButton searchButton " v-if="swshow2&&info.back!=1" style="background-color: #e60000;" @click="back(2)">驳回到维修环节</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="工单查看" :visible.sync="detailShow" append-to-body :close-on-click-modal='false' width="1600px"
		 v-dialogDrag top="1%" :before-close="handleClose" custom-class="dialogBox" class="MAdialog">
			<div class="dialogBoxMes" style="height: 100%">
				<div class="pdfShow">
					<iframe v-if="info.approvalFileId!=null" frameborder="0" :src="$store.getters.getPostUrl+'mes/sysFile/pdf/'+info.approvalFileId"
					 width='100%' height="520px">
					</iframe>
					<iframe v-if="info.approvalFileId==null" frameborder="0" :src="$store.getters.getPostUrl+'mes/sysFile/pdf/'+info.taskFileId"
					 width='100%' height="520px">
					</iframe>
				</div>

				<span slot="footer" class="dialog-footer">
					<div style="width: 320px; height: 34px; margin: 0 auto;">
						<div class="chooseButton sendButton" style="margin: 0; float: left; margin-right: 20px;" @click="ApprovalDetailShow=true">会签单</div>
<!--						<div class="chooseButton sendButton" style="margin: 0; float: left;" @click="pdf">导出</div>-->
					</div>
				</span>
				<div class="stepList proSpotMes approve">
					<el-steps align-center :active="stepActive">
						<template v-for="(item,index) in ApprovalList">
							<el-step>
								<template slot="description">
									<div :class="['steps_div',(item.time!=''&&item.time!=null)?'steps_div_1':'steps_div_0']">
										<div><span class="steps_div_span1">审批人</span>：<span>{{(item.time!=''&&item.time!=null)?item.userName:'--'}}</span>
										</div>
										<div><span class="steps_div_span1">审批时间</span>：<span>{{(item.time!=''&&item.time!=null)?item.time:'--'}}</span>
										</div>
										<!-- <div><span class="steps_div_span1">审批意见</span>：<span>{{(item.time!=''&&item.time!=null)?item.remark:'--'}}</span>
										</div> -->
									</div>
								</template>
							</el-step>
						</template>
					</el-steps>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="会签单" :visible.sync="ApprovalDetailShow" append-to-body :close-on-click-modal='false' width="800px"
		 v-dialogDrag top="10%" :before-close="handleClose3" custom-class="dialogBox">
			<div class="dialogBoxMes" style="height: 500px">
				<el-table :empty-text="$t('label_357')" :data="ApprovalDetail" border style="width: calc(100% - 2px);margin: 10px 0" :header-cell-style="{'background-color': '#45494f','color': '#ffffff'}">
					<el-table-column prop="userName" label="审批人" width="180">
					</el-table-column>
					<el-table-column prop="createTime" align="center" label="审批时间" width="180">
					</el-table-column>
					<el-table-column prop="remark" label="审批意见">
					</el-table-column>
					<el-table-column prop="type" label="审批结果" align="center">
						<template slot-scope="scope">
							{{scope.row.type==1?'驳回':'通过'}}
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import tree from "@/components/list/tree/maintainTree";
	import maintenance from "@/assets/js/maintenance/maintenance.js";
	import malfunction from "@/assets/js/malfunction/malfunction.js";
	import file from "@/assets/js/file/file.js";
	import partInfo from "@/components/list/repair/partInfo";
	export default {
		name: 'spotResumePage',
		components: {
			Page,
			tree,
			partInfo
		},
		data() {
			return {
				timers:null,
				textarea: '',
				turnDialogShow: false,
				detailShow: false,
				dialogShow: false,
				turnDialogShow2: false,
				ApprovalDetailShow: false,
				switched: true,
				swshow: false,
				faultLevel2: [{
					value: '',
					label: '全部故障'
				}, {
					value: '一般故障',
					label: '一般故障'
				}, {
					value: '紧急故障',
					label: '紧急故障'
				}, {
					value: '重大故障',
					label: '重大故障'
				}, {
					value: '未知故障',
					label: '未知故障'
				}],
				pageNum: 1,
				select: 0,
				pageSize: 10,
				pageCount: 0,
				height: 500,
				Readytime: '',
				ApprovalList: [],
				ApprovalDetail: [],
				getTreeMes: '1',
				checkComfrim: ['断开控制柜柜内直流电源开关', '断开控制柜柜内交流电源开关', '绝缘手套佩戴完毕1'],
				checked: false,
				dialogSpotResult: false,
				dialogSpotTimeEdit: false,
				dialogSpotBatchTimeEdit: false,
				dialogImg: false,
				dialogVideo: false,
				fengXianConfrim: [],
				info: {},
				faultList: [{
					text: '一般故障',
					color: '#aeaeae'
				}, {
					text: '紧急故障',
					color: '#ffb400'
				}, {
					text: '重大故障',
					color: '#e60000'
				}, {
					text: '未知故障',
					color: '#0353c1'
				}],
				tableDataTree: [],
				treeData: {
					dataDevice: [],
					searchShow: true,
					statusShow: false,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '2'
				},
				treeData2: {
					dataDevice: [],
					searchShow: true,
					statusShow: false,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '3'
				},
				tableDataTreeTime: [],
				activeNameTree: 'second',
				activeNameSpot: 'spot',
				mainEditTree: 'project',
				deviceDetailMes: {},
				tableDataTreeInfo: [],
				typeName: '',
				deptName: '',
				status: '',
				faultLevel: '',
				changeStatus: '',
				spotStatusNumList: [{
					text: '全部',
					type: '0',
					check: false,
					num: '4',
					color: '#000000'
				}, {
					text: '待派单',
					type: '1',
					check: false,
					num: '0',
					color: '#e60000'
				}, {
					text: '待接单',
					type: '2',
					check: false,
					num: '0',
					color: '#e60000'
				}, {
					text: '待维修',
					type: '3',
					check: false,
					num: '0',
					color: '#e60000'
				}, {
					text: '维修中',
					type: '4',
					check: false,
					num: '1',
					color: '#ffb400'
				}, {
					text: '待验收',
					type: '5',
					check: false,
					num: '1',
					color: '#e60000'
				}, {
					text: '验收中',
					type: '6',
					check: false,
					num: '1',
					color: '#ffb400'
				}, {
					text: '已完成',
					type: '7',
					check: true,
					num: '1',
					color: '#3fb393'
				}, {
					text: '已关闭',
					type: '8',
					check: false,
					num: '0',
					color: '#aeaeae'
				}],
				img: '',
				orderNo: '',
				mainEditList: {
					equipmentId: '',
					faultPhenomenon: '',
					fault: '',
					devicName: '',
					reportPerson: '',
					mobile: '',
					urgentLevel: '',
					faultSource: '',
					stop: '1',
					expectTime: '',
					reportTime: '',
					stopTime: '',
					faultExplain: '',
					faultImg: '',
					status: '1',
					superior: '',
					repairImg: [],
					deptId: '',
					distinction: '0'
				},
				allList: [],
				stepsSimple: false,
				urgentList: [],
				fileList: [],
				lookFlag: 4,
				tableDataEdit: {
					id: '',
					risk: [],
					repairMode: [],
					faultLevel: '',
					remarks: '',
					repairman: [],
					repairmanId: '',
					accepter: '',
					accepterId: '',
					participants: '',
					participantsId: '',
					needAccepter: 1,
					importants: '',
					delayedDay: '',
					other: '',
					other1: '',
					otherInput: '',
					other2: '',
					otherInput2: '',
					delayedReason: '',
					reason: [],
					productTrackList: [],
					bulkTrackList: []
				},
				malfunctionList: [],
				riskList: [],
				maintainList: [],
				loading: false,
				selectValue: '',
				stepActive: 0,
				options: [],
				selectValue3: '',
				options3: [],
				selectValue2: [],
				options2: [],
				mainEditSheet: 'feng2',
				receiveList: {
					idea: '',
					accord: '',
					userName: '',
					passWord: '',
					autograph: '',
					confirm: '',
					taskId: '',
					riskIdList: [],
					id: '',
					flag: "0",
					distinction: ''
				},
				riskConfrimData: [],
				checkList100: [],
				delayedList: [],
				knowledgeListNew: [],
				knowledgeSelect: {
					faultReasonClassify: '',
					faultReason: '',
					faultExplain: '',
				},
				cause: [],
				causeList: [],
				knowledgeCheckList: [],
				knowledgeList: [],
				productTrackList: [],
				bulkTrackList: [],
				id: '',
				statusList: [],
				MenuRoleList: [],
				swshow2: false,
			}
		},
		methods: {
			pdf(){
				if(this.info.nodeName=='已结束'){
					window.open(this.$store.getters.getPostUrl + 'mes/sysFile/download/' + this.info.approvalFileId, "_blank")
				}else{
					utils.messageAlert("只能导出已结束的工单", this.$t('label_358'), this.$t('label_100'));
				}
			},
			Dshow(type) {
				this.textarea = '';
				if (type == 1) {
					this.turnDialogShow = true
				} else {
					this.turnDialogShow2 = true
				}
			},
			handleClose() {
				this.dialogShow = false;
				this.detailShow = false;
			},
			handleClose2() {
				this.turnDialogShow = false;
				this.turnDialogShow2 = false;
			},
			handleClose3() {
				this.ApprovalDetailShow = false;
			},
			handler(row) {

			},
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			selectProp: function(index) {
				// console.log(index)
				this.select = index
			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			handleCurrentChangeTreeTime(info) {
				this.info = info;
				// this.id = info.id;
				// this.selectAll();
			},
			handleClickTree(tab, event) {
				this.getTreeMes = '1';
				this.deviceDetailMes = {};
				// this.search({
				// 	pageNum: 1,
				// 	pageSize: this.pageSize,
				// });
			},
			search(param) {
				this.tableDataTreeTime = [];
				this.info = {};
				this.pageCount = 0;
				let status = [];
				for (let i = 0; i < this.spotStatusNumList.length; i++) {
					if (this.spotStatusNumList[i].check == true) {
						status.push(i)
					}
				}
				let arr = this.changeStatus.split("&@");
				if (arr[0] == '') {
					arr.push('');
				}
				let dataParam = {
					beginTime: this.Readytime[0] + " 00:00:00",
					endTime: this.Readytime[1] + " 23:59:59",
					faultLevel: this.faultLevel,
					status: status,
					orderNo: this.orderNo,
					type: this.deviceDetailMes.type,
					id: this.deviceDetailMes.id,
					nodeId: arr[0],
					nodeName: arr[1]
				}
				let newParam = Object.assign(param, dataParam);
				this.pageNum = newParam.pageNum;
				this.pageSize = newParam.pageSize;
				this.searchPage(newParam);
			},
			searchPage(param) {
				malfunction.selectPage2(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataTreeTime = data.data.list
						this.pageSize = data.data.size;
						this.pageCount = data.data.total;
						this.pageNum = data.data.pageNum;
						this.$refs['pageModel'].setCurrent(this.pageNum);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			searchStauts(param) {
				malfunction.getRecordStatus(param, this.switched).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.spotStatusNumList[0].num = data.data.num0
						this.spotStatusNumList[1].num = data.data.num1
						this.spotStatusNumList[2].num = data.data.num2
						this.spotStatusNumList[3].num = data.data.num3
						this.spotStatusNumList[4].num = data.data.num4
						this.spotStatusNumList[5].num = data.data.num5
						this.spotStatusNumList[6].num = data.data.num6
						this.spotStatusNumList[7].num = data.data.num7
						this.spotStatusNumList[8].num = data.data.num8
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			getDeviceMes(data) {
				if (data.name == this.$t('label_272')) {
					this.deviceDetailMes = {};
					this.search({
						pageNum: 1,
						pageSize: this.pageSize,
					});
				} else {
					this.deviceDetailMes = data;
					this.search({
						pageNum: 1,
						pageSize: this.pageSize,
					});
				}
			},
			getNowTime() {
				let zeroTime = new Date();
				let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() +
					1; //月份从0开始，因此要+1
				let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
				let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
				return now;
			},
			getThreeDaysAgo() {
				let myDate = new Date();
				let lw = new Date(myDate - 1000 * 60 * 60 * 24 * 30); //最后一个数字30可改，30天的意思
				let lastY = lw.getFullYear();
				let lastM = lw.getMonth() + 1;
				let lastD = lw.getDate();
				let startData =
					lastY +
					"-" +
					(lastM < 10 ? "0" + lastM : lastM) +
					"-" +
					(lastD < 10 ? "0" + lastD : lastD); //三十天之前日期
				return startData;
			},
			selectdictList() {
        file.getByDictIdALL({dictId: 15, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.malfunctionList = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getDictList(15).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.malfunctionList = data.data
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
			},
			approve() {
				this.swshow = false;
				this.swshow2 = false;
				if (Object.keys(this.info).length > 0) {
					if (this.info.nodeName == '已结束') {
						utils.messageAlert("该审批工单已结束,可进行查看", this.$t('label_358'), this.$t('label_100'));
						return;
					} else {
						this.dialogShow = true;
						if (this.info.nodeName.indexOf('课长') >= 0) {
							this.swshow = true;
						} else if (this.info.nodeName.indexOf('发起人') >= 0) {
							this.swshow2 = true;
						}
						s
					}
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			approveDetailsShow() {
				if (Object.keys(this.info).length > 0) {
					this.detailShow = true;
					malfunction.getApproveList(this.info.appId).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							let stepList = data.data.ApprovalList
							//this.malfunctionList = data.data
							this.stepActive = 0;
							for (let i = 0; i < stepList.length; i++) {
								if (stepList[i].time != "" && stepList[i].time != null) {
									this.stepActive = i + 1;
								}
							}
							this.ApprovalDetail = data.data.ApprovalDetail;
							this.ApprovalList = data.data.ApprovalList;
						}
					}).catch((response) => {
						console.log(response)
					})
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			back(type) {
				let that = this;
				const loading = that.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				let param = {
					id: this.info.id,
					type: type,
				}
				malfunction.back(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.dialogShow = false;
						this.swshow2 = false;
						loading.close();
						this.$message({
							message: this.$t('msg_23'),
							type: 'success'
						});
						this.search({
							pageNum: this.pageNum,
							pageSize: this.pageSize,
						});
					}
				}).catch((response) => {
					loading.close();
					console.log(response)
				})

			},
			agree() {
				let that = this;
				const loading = that.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				let param = {
					id: this.info.appId,
					remark: this.textarea,
					type: '0',
					accessoryId: '',
					valid: Number(this.info.valid)
				}
				malfunction.approve(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.turnDialogShow2 = false;
						this.dialogShow = false;
						loading.close();
						this.$message({
							message: this.$t('msg_23'),
							type: 'success'
						});
						this.search({
							pageNum: this.pageNum,
							pageSize: this.pageSize,
						});
					}
				}).catch((response) => {
					loading.close();
					console.log(response)
				})
			},
			oppose() {
				let that = this;
				const loading = that.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				let param = {
					id: this.info.appId,
					remark: this.textarea,
					type: '1',
					accessoryId: '',
					valid: Number(this.info.valid)
				}
				malfunction.approve(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.turnDialogShow = false;
						this.dialogShow = false;
						loading.close();
						this.$message({
							message: this.$t('msg_23'),
							type: 'success'
						});
						this.search({
							pageNum: this.pageNum,
							pageSize: this.pageSize,
						});
					}
				}).catch((response) => {
					loading.close();
					console.log(response)
				})
			},
			selectStatusList() {
				malfunction.approveStatus().then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.statusList = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
		},
		created() {
			this.Readytime = [this.getThreeDaysAgo(), this.getNowTime()]
			this.MenuRoleList = this.$store.getters.getMenu;
			this.selectdictList();
			this.selectStatusList();
		}
	}
</script>
<style>
	.turnDialog .el-dialog__body {
		height: 90%;
	}

	.turnDialog .el-dialog {
		height: 60%;
	}

	.cenDiv {
		width: auto;
		margin: 0 auto;
	}

	.MAbtn {
		width: 100%;
		display: -webkit-box;
	}

	.MAdialog .el-dialog {
		height: 92%;
	}

	.MAdialog .el-dialog__body {
		height: 93%;
	}

	.MAdialogBody {
		height: calc(100% - 60px);
	}

	.MAdialogBody2 {
		height: auto;
		margin-bottom: 20px;
	}

	.pdfShow {
		height: calc(100% - 200px);
	}

	.turnDialog .el-input__inner {
		height: 90%;
	}

	.stepList .steps_div {
		width: auto;
	}

	.approve .el-step.is-center .el-step__description {
		padding-left: 5%;
		padding-right: 5%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/approve/malfunctionApproveView.vue